@if (offer) {
  <div class="img-modal open" aria-hidden="false">
    <div class="backdrop" (click)="closeModal()" aria-hidden="true"></div>

    <div class="panel" role="dialog" aria-modal="true" aria-label="Room images" tabindex="-1">
      <div class="panel-header">
        <div class="panel-title">
          {{ offer.amenities.upsell_room_name || offer.upsell_room_category_name || 'Room Images' }}
        </div>
        <button class="close-btn" type="button" aria-label="Close" (click)="closeModal()">
          <span class="material-icons">close</span>
        </button>
      </div>

      <div class="panel-body">
        <div class="modal-media">
          <div
            class="img-carousel"
            [attr.data-count]="images.length"
            (pointerdown)="onPointerDown($event)"
            (pointerup)="onPointerUp($event)"
            (pointercancel)="onPointerCancel()"
            (pointerleave)="onPointerCancel()">
            @if (hasImages) {
              <img class="offer-image" [src]="currentImageUrl" alt="Room image" decoding="async" loading="lazy" />

              @if (images.length > 1) {
                <button type="button" class="carousel-btn prev" [lxResponsiveClass]="arrowResponsiveClass" aria-label="Previous image" (click)="prevImage($event)">
                  <span class="material-icons">chevron_left</span>
                </button>
                <button type="button" class="carousel-btn next" [lxResponsiveClass]="arrowResponsiveClass" aria-label="Next image" (click)="nextImage($event)">
                  <span class="material-icons">chevron_right</span>
                </button>

                <div class="carousel-dots" aria-hidden="true">
                  @for (img of images; track img; let i = $index) {
                    <div
                      class="carousel-dot"
                      [class.active]="i === currentImageIndex"
                      (click)="goTo(i, $event)"></div>
                  }
                </div>
              }
            } @else {
              <div class="no-image">No image</div>
            }
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="modal-price">
          @if (shouldShowStrike()) {
            <span class="strike">{{ offer.bar_price | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
          }
          <span class="price-main">{{ offer.ofr_price | currency : 'USD' : 'symbol' : '1.0-0' }} per night</span>&nbsp;          
        </div>

        <button class="btn-cta modal-add" type="button" (click)="onPrimaryAction()">
          <span class="material-icons cart-icon">{{ primaryActionIcon }}</span>
          <span class="cart-label">{{ primaryActionLabel }}</span>
        </button>
      </div>
    </div>
  </div>
}
